import { eTitleFees } from 'ui-toolkit/enums/eTitleFees';

export type TOwnerPolicyFeeTypes = eTitleFees.standard_owners_policy | eTitleFees.homeowners_policy;
export type TLendersPolicyFeeTypes = eTitleFees.lenders_policy | eTitleFees.extended_lenders_policy;
export type TPolicyFeeTypes = TOwnerPolicyFeeTypes | TLendersPolicyFeeTypes;
export const ownersPolicyFeeTypes: TOwnerPolicyFeeTypes[] = [
  eTitleFees.standard_owners_policy,
  eTitleFees.homeowners_policy,
];
export const lendersPolicyFeeTypes: TLendersPolicyFeeTypes[] = [
  eTitleFees.lenders_policy,
  eTitleFees.extended_lenders_policy,
];
export const policyFeeTypes: TPolicyFeeTypes[] = [...ownersPolicyFeeTypes, ...lendersPolicyFeeTypes];
